import { render, staticRenderFns } from "./WarningModalBuy.vue?vue&type=template&id=bb11b44c&"
import script from "./WarningModalBuy.vue?vue&type=script&lang=js&"
export * from "./WarningModalBuy.vue?vue&type=script&lang=js&"
import style0 from "./WarningModalBuy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports